function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
const MondayAiIcon = ({ disabled = false, size = 18, className })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        children: /*#__PURE__*/ _jsx("img", {
            src: "/static/img/monday-ai.png",
            alt: "Monday AI",
            width: size,
            height: size,
            style: _object_spread({
                display: 'block'
            }, disabled && {
                filter: 'grayscale(100%)',
                opacity: 0.7
            })
        })
    });
};
MondayAiIcon.propTypes = {
    disabled: PropTypes.bool,
    size: PropTypes.number,
    className: PropTypes.string
};
export default MondayAiIcon;
